import { useEffect, useState } from "react";
import { Add, Edit } from "@mui/icons-material";
import { Button, IconButton, Modal, Typography } from "@mui/material";
import { Box } from "@mui/material/node_modules/@mui/system";
import { GridColDef } from "@mui/x-data-grid";
import { Brand, getImageById, Image } from "api";
import { ImagesGallery } from "components/ImageGallery/ImageGallery";

interface GenerateImageGridColDefProps {
  field: string;
  headerName: string;
  width?: number;
  activeBrand?: Brand;
}

interface ImagePickListModalProps {
  onImageChange: Function;
  activeBrand?: Brand;
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '300px',
  maxWidth: '600px',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  maxHeight: '50%',
  overflow: 'scroll'
};

export function ImagePickListModal({ onImageChange, activeBrand }: ImagePickListModalProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <>
      <Button
        size={'small'}
        onClick={() => setIsModalVisible(true)}
      >
        <Edit />
      </Button>
      <Modal
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Image Gallery
          </Typography>
          <ImagesGallery
            activeBrand={activeBrand}
            actionButton={(item) => (
              <IconButton onClick={() => {
                onImageChange(item);
                setIsModalVisible(false);
              }}>
                <Add />
              </IconButton>
            )}
          />
        </Box>
      </Modal>
    </>
  );
}

export function generateImageGridColDef({ field, headerName, width, activeBrand }: GenerateImageGridColDefProps): GridColDef {
  const onImageChange = ({ api, id, field, data }: any) => {
    api.setEditCellValue({
      id,
      field,
      value: { id: data.id, brandId: data.brandId }
    });
  };

  return {
    field,
    headerName,
    editable: true,
    minWidth: width || 250,
    renderCell: ({ value }) => value && <ImageRender value={value as any} />,
    renderEditCell: ({ id, field, value, api }) => (
      <>
        {value && <ImageRender value={value as any} />}
        <br />
        <ImagePickListModal
          activeBrand={activeBrand}
          onImageChange={(data: Image) => onImageChange({ id, field, api, data })}
        />
      </>
    ),
  };
}

type TImageRenderProps = {
  value: { id: string, brandId: string }
}
const ImageRender = ({ value }: TImageRenderProps) => {
  // TODO: get image from api
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  useEffect(() => {
    getImageById({ id: value.id, brandId: value.brandId }).then((image) => {
      setImageUrl(image.url);
    });
  }, [value]);
  return imageUrl ? (
    <img src={imageUrl} width={100} alt={'product'} />
  ) : null;
}